<template>
	<div class="ms-daterange ms-editor">
		<div class="period">
			<div class="title">{{ titlePeriod }}</div>
			<ms-combobox
				displayField="text"
				valueField="value"
				queryMode="local"
				:data="dataDateRange"
				keyField="value"
				v-model="selectedPeriod"
				:dropdownWidth="160"
				class="hx-32"
			></ms-combobox>
		</div>
		<div class="from-date ml-4">
			<div class="title">{{ titleFromDate }}</div>
			<ms-datepicker
				v-model="fromDatex"
				@change="changeFromDate"
				rules="required"
				class="hx-32"
				ref="fromDate"
				:name="$t('i18nCommon.FromDate')"
			></ms-datepicker>
		</div>
		<div class="to-date ml-4">
			<div class="title">{{ titleToDate }}</div>
			<ms-datepicker
				v-model="toDatex"
				@change="changeToDate"
				rules="required"
				class="hx-32"
				ref="toDate"
				:name="$t('i18nCommon.ToDate')"
			></ms-datepicker>
		</div>
	</div>
</template>
<script>
import MSStore from '@/store/msstore';
import { MSEnum } from '../../common/enumeration';
import DateRange from './DateRange';
const Period = MSEnum.Period;
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';

export default {
	name: 'MsDaterange',
	extends: msBaseComponent,

	props: {
		fromDate: {
			default: null,
			required: true,
		},
		toDate: {
			default: null,
			required: true,
		},
		initDefault: {
			default: 45,
			type: Number,
		},
		titlePeriod: {
			default: null,
			type: String,
		},
		titleFromDate: {
			default: null,
			type: String,
		},
		titleToDate: {
			default: null,
			type: String,
		},
		period: {
			default: null,
		},
		enumPeriod: {
			default: null,
			type: String,
		},
	},
	data() {
		return {
			dataDateRange: [],
			fromDatex: null,
			toDatex: null,
			selectedPeriod: null,
		};
	},
	watch: {
		fromDatex: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				let tmp = me.setTimeFromDate(newVal);
				me.$emit('update:fromDate', tmp);
				me.$nextTick(() => {
					me.validate('fromDate');
				});
			},
		},
		toDatex: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				let tmp = me.setTimeToDate(newVal);
				me.$emit('update:toDate', tmp);
				me.$nextTick(() => {
					me.validate('toDate');
				});
			},
		},
		selectedPeriod: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != 0) {
					me.changeDate(newVal);
				}
			},
		},
	},
	methods: {
		validate(ele) {
			const me = this;
			let errorProvider = {};
			if (me.fromDatex && me.toDatex) {
				let from = new Date(me.fromDatex);
				let to = new Date(me.toDatex);
				if (from.getTime() > to.getTime()) {
					if (ele == 'toDate') {
						me.$refs.toDate.applyValidate(
							me.$t('i18nComponent.ValidateToDate')
						);
						me.$refs.fromDate.applyValidate(null);
						errorProvider = me.$refs.toDate.errorProvider;
					} else {
						me.$refs.toDate.applyValidate(null);
						me.$refs.fromDate.applyValidate(
							me.$t('i18nComponent.ValidateFromDate')
						);
						errorProvider = me.$refs.fromDate.errorProvider;
					}
				} else {
					me.$refs.toDate.applyValidate(null);
					me.$refs.fromDate.applyValidate(null);
				}
			}
			return errorProvider;
		},
		setTimeFromDate(fromDate) {
			if (fromDate) {
				let tmpDate = new Date(fromDate);
				tmpDate.setMinutes(tmpDate.getMinutes() - tmpDate.getTimezoneOffset());
				tmpDate = tmpDate.toISOString();
				return tmpDate;
			}
		},
		setTimeToDate(toDate) {
			if (toDate) {
				let tmpDate = new Date(toDate);
				tmpDate.setHours(23, 59, 59);
				tmpDate.setMinutes(tmpDate.getMinutes() - tmpDate.getTimezoneOffset());
				tmpDate = tmpDate.toISOString();
				return tmpDate;
			}
		},
		changeFromDate(value) {
			const me = this;
			this.selectedPeriod = 0;
			if (this.toDatex && this.fromDatex) {
				this.selectedPeriod = DateRange.caculatePeriodFromRange(
					this.fromDatex,
					this.toDatex
				);
			}
			me.$emit('update:period', this.selectedPeriod);
		},
		changeToDate(value) {
			const me = this;
			this.selectedPeriod = 0;
			if (this.toDatex && this.fromDatex) {
				this.selectedPeriod = DateRange.caculatePeriodFromRange(
					this.fromDatex,
					this.toDatex
				);
			}
			me.$emit('update:period', this.selectedPeriod);
		},
		changeDate(value) {
			let range = DateRange.caculateRangeFromPeriod(value),
				fromDate = range.fromDate,
				toDate = range.toDate;
			this.fromDatex = fromDate;
			this.toDatex = toDate;
		},
		resetDataDefault() {
			const me = this;
			this.selectedPeriod = this.initDefault;
			me.$emit('update:period', this.selectedPeriod);
		},
	},
	created() {
		const me = this;
		let x = this.$t('i18nDateRange'),
			dataRange = [];
		let PeriodData = Period;
		if (this.enumPeriod) {
			PeriodData = MSEnum[this.enumPeriod];
		}
		for (let key in PeriodData) {
			let obj = {
				text: x[key],
				value: PeriodData[key],
			};
			dataRange.push(obj);
		}
		me.dataDateRange = dataRange;
		this.selectedPeriod = this.initDefault;
		me.$emit('update:period', this.selectedPeriod);
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msDateRanger.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msDateRanger.scss';
}
</style>

